import { render, staticRenderFns } from "./ClassifierValuesListItem.vue?vue&type=template&id=84b1fd86&lang=pug&"
import script from "./ClassifierValuesListItem.vue?vue&type=script&lang=js&"
export * from "./ClassifierValuesListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports